import React, { useContext, useState } from 'react';
import { AuthContext } from './AuthContext';
import './Account.css';

const Account = () => {
  const { user } = useContext(AuthContext);
  const [passwordForm, setPasswordForm] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: '',
  });
  const [status, setStatus] = useState(null);
  const [saving, setSaving] = useState(false);

  const displayName = [user?.firstName, user?.lastName].filter(Boolean).join(' ') || 'Your account';

  const handlePasswordChange = (event) => {
    const { name, value } = event.target;
    setPasswordForm((current) => ({ ...current, [name]: value }));
  };

  const handlePasswordSubmit = async (event) => {
    event.preventDefault();
    setSaving(true);
    setStatus(null);

    try {
      const response = await fetch('/api/account/password', {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token') || ''}`,
        },
        body: JSON.stringify(passwordForm),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Unable to update password.');
      }

      setPasswordForm({
        currentPassword: '',
        newPassword: '',
        confirmPassword: '',
      });
      setStatus({ type: 'success', message: data.message || 'Password updated.' });
    } catch (error) {
      setStatus({ type: 'error', message: error.message });
    } finally {
      setSaving(false);
    }
  };

  return (
    <main className="account-page">
      <section className="account-shell">
        <div className="account-header">
          <div>
            <p className="account-eyebrow">Account</p>
            <h1>Security settings</h1>
            <p>Manage how you sign in and keep your VetBill account protected.</p>
          </div>
        </div>

        <div className="account-grid">
          <section className="account-card">
            <h2>Sign-in details</h2>
            <div className="account-detail-list">
              <div className="account-detail">
                <span>Name</span>
                <strong>{displayName}</strong>
              </div>
              <div className="account-detail">
                <span>Email</span>
                <strong>{user?.email || 'No email saved'}</strong>
              </div>
            </div>
            <p className="account-note">
              Profile edits are kept separate from security settings so password changes stay focused and easier to verify.
            </p>
          </section>

          <section className="account-card account-card-primary">
            <div className="account-card-header">
              <div>
                <h2>Change password</h2>
                <p>Use at least 8 characters. A unique password is best.</p>
              </div>
            </div>

            {status && (
              <div className={`account-status account-status-${status.type}`} role="status">
                {status.message}
              </div>
            )}

            <form className="account-form" onSubmit={handlePasswordSubmit}>
              <label>
                Current password
                <input
                  type="password"
                  name="currentPassword"
                  value={passwordForm.currentPassword}
                  onChange={handlePasswordChange}
                  autoComplete="current-password"
                  required
                />
              </label>
              <label>
                New password
                <input
                  type="password"
                  name="newPassword"
                  value={passwordForm.newPassword}
                  onChange={handlePasswordChange}
                  autoComplete="new-password"
                  minLength="8"
                  required
                />
              </label>
              <label>
                Confirm new password
                <input
                  type="password"
                  name="confirmPassword"
                  value={passwordForm.confirmPassword}
                  onChange={handlePasswordChange}
                  autoComplete="new-password"
                  minLength="8"
                  required
                />
              </label>
              <button type="submit" className="account-primary-button" disabled={saving}>
                {saving ? 'Updating...' : 'Update password'}
              </button>
            </form>
          </section>
        </div>
      </section>
    </main>
  );
};

export default Account;
